module.exports = __webpack_public_path__ + "img/redirect_popup-2.b6592a30.png";